module.exports = __webpack_public_path__ + "img/proyecto_14.dfe85825.webp";